/* eslint-disable import/prefer-default-export */

const contentType = (
  labelText,
  menuText,
  labelColor,
  slug,
  contentfulTypeKey
) => ({
  labelText,
  menuText,
  labelColor,
  slug,
  contentfulTypeKey,
});

const ALL_TYPE = contentType('All', 'All Resources', 'primary', null, 'all');

export const ALL_TYPE_KEY = ALL_TYPE.contentfulTypeKey;

export const CONTENTFUL_TYPES = {
  all: ALL_TYPE,
  ContentfulWebinar: contentType(
    'Webinar',
    'Webinars',
    'purple',
    'webinars',
    'ContentfulWebinar'
  ),
  ContentfulWhitepaper: contentType(
    'White Paper',
    'White Papers',
    'primary',
    'whitepapers',
    'ContentfulWhitepaper'
  ),
};

export const getHumanReadableContentTypeFromContentfulType = contentfulType =>
  CONTENTFUL_TYPES[contentfulType].labelText;

export const getSlugFromContentfulType = contentfulType =>
  CONTENTFUL_TYPES[contentfulType].slug;

export const getBackgroundColorFromContentfulType = contentfulType => waffles =>
  waffles.theme.colors[CONTENTFUL_TYPES[contentfulType].labelColor];

const contentTypeFromSlug = slug =>
  Object.values(CONTENTFUL_TYPES).find(
    contentfulType => contentfulType.slug === slug
  ) || ALL_TYPE;

export const getContentfulTypeKeyFromSlug = slug =>
  contentTypeFromSlug(slug).contentfulTypeKey;
